import type { StackProps } from '@chakra-ui/react';
import { HStack, Link, Text } from '@chakra-ui/react';
import { MaskIcon } from '@ui/components/MaskIcon';
import { EXTERNAL_LINK } from '@ui/config/externalLinks';

export const SocialLinks = (props: StackProps) => {
  return (
    <HStack textStyle="body2" justify="space-between" {...props}>
      <Text>Follow us</Text>
      <HStack gap={4}>
        <Link
          rel="noopener noreferrer"
          href={EXTERNAL_LINK.twitter}
          target="_blank"
        >
          <MaskIcon
            color="primary"
            icon="url(/masks/twitter-icon.svg), url(/masks/twitter-body.svg)"
            boxSize="22px"
          />
        </Link>
        <Link
          rel="noopener noreferrer"
          href={EXTERNAL_LINK.discord}
          target="_blank"
        >
          <MaskIcon
            color="primary"
            icon="url(/masks/discord.svg)"
            boxSize="22px"
          />
        </Link>
        <Link
          rel="noopener noreferrer"
          href={EXTERNAL_LINK.gitbook}
          target="_blank"
        >
          <MaskIcon
            color="primary"
            icon="url(/masks/gitbook.svg)"
            boxSize="22px"
          />
        </Link>
      </HStack>
    </HStack>
  );
};
